module.exports = __webpack_public_path__ + "static/img/PBF.cbfc26ed.svg";